/* eslint-disable react-hooks/exhaustive-deps */
import { useToast } from "@/hooks/use-toast";
import { GenericType } from "@/types";
import { zodResolver } from "@hookform/resolvers/zod";
import { useEffect } from "react";
import { useForm } from "react-hook-form";

import { z } from "zod";

type UseUserformType = {
  formData: GenericType;
  onFormSubmit: (prop: GenericType) => Promise<GenericType>;
  open: boolean;
  onOpenChange: (prop: boolean) => void;
};

const formSchema = z.object({
  structured: z.boolean()?.optional(),
  file_path: z.any(),
  instructions: z.any(),
  domain_name: z.any(),
  retailer_id: z.string().min(1, {
    message: "Retailer name is required.",
  }),
});

export const useReactForm = ({
  formData,
  onFormSubmit,
  onOpenChange,
}: // open,
UseUserformType) => {
  const { toast } = useToast();
  const schemaKeys = formSchema.keyof().options;

  const form = useForm<z.infer<typeof formSchema>>({
    resolver: zodResolver(formSchema),
    defaultValues: {
      structured: false,
      retailer_id: "",
      file_path: "",
      instructions: "",
      domain_name: "",
    },
  });

  useEffect(() => {
    if (formData && Object.keys(formData).length > 0) {
      schemaKeys.forEach((key) => {
        if (formData[key]) {
          const value = formData[key];
          form.setValue(key, value, {
            shouldTouch: true,
            shouldDirty: true,
          });
        }
      });
    }
  }, [formData]);

  async function onSubmit(values: z.infer<typeof formSchema>) {
    const { data } = await onFormSubmit(values);
    if (data) {
      toast({
        title: "Success",
        variant: "success",
        description: data.status.msg,
      });
      onOpenChange(false);
    }
  }

  return { form, onSubmit };
};
